import script from "./SilentBoxGallery.vue?vue&type=script&lang=ts&setup=true"
export * from "./SilentBoxGallery.vue?vue&type=script&lang=ts&setup=true"

import "./SilentBoxGallery.vue?vue&type=style&index=0&id=794966e8&lang=scss"

const __exports__ = script;

export default __exports__